import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import ScanPage from './ScanPage';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyScan } from './companyScanApi';

/**
 * Company Scans → one scan's page.
 *
 * All three scan routes render this component; the scan is the last segment of
 * the path, which is also the key the backend expects. Three near-identical
 * route wrappers would have said nothing the URL doesn't already say.
 */
const SCAN_TITLES = {
  skin: 'Skin Scan',
  teeth: 'Teeth Scan',
  age: 'Age Scan'
};

const CScanPage = () => {
  const location = useLocation();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const scan = location.pathname.split('/').filter(Boolean).pop();

  const fetcher = useCallback(
    () => fetchCompanyScan(scan, department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [scan, isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{SCAN_TITLES[scan] || 'Scans'} | Shoorah</title>
      </Helmet>
      <ScanPage
        scan={scan}
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CScanPage;
